document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.ag-contact-page');
  if (!section) return;
  section.classList.add('is-enhanced');

  var heroBackground = section.querySelector('.ag-contact__hero-bg');
  var heroVideo = section.querySelector('.ag-contact__hero-video');
  var subjectSelect = section.querySelector('#ContactFormSubject');
  var subjectButtons = section.querySelectorAll('[data-contact-subject]');
  var routeCards = section.querySelectorAll('[data-contact-route]');
  var routeFieldWrap = section.querySelector('[data-contact-route-fields]');
  var routeFields = section.querySelectorAll('[data-contact-route-field]');
  var routeControlInitialDisabled = new WeakMap();
  var faqItems = section.querySelectorAll('.ag-contact-body-faq__item');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reduceMotion && reduceMotion.matches;
  }

  function markHeroVideoReady() {
    if (!heroBackground) return;
    heroBackground.classList.add('is-video-ready');
  }

  if (heroVideo && heroBackground) {
    if (heroVideo.readyState >= 2) {
      markHeroVideoReady();
    } else {
      heroVideo.addEventListener('loadeddata', markHeroVideoReady, { once: true });
    }
  }

  function syncSubjectButtons(value) {
    subjectButtons.forEach(function (button) {
      var isActive = button.getAttribute('data-contact-subject') === value;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function syncRouteCards(value) {
    routeCards.forEach(function (card) {
      var isActive = card.getAttribute('data-contact-route') === value || card.getAttribute('data-contact-subject') === value;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function syncRouteFields(value) {
    if (!routeFieldWrap || !routeFields || routeFields.length === 0) return;
    var anyShown = false;
    routeFields.forEach(function (field) {
      var match = field.getAttribute('data-contact-route-field') === value;
      field.hidden = !match;
      field.querySelectorAll('input, select, textarea').forEach(function (control) {
        if (!routeControlInitialDisabled.has(control)) {
          routeControlInitialDisabled.set(control, control.disabled);
        }
        control.disabled = !match || routeControlInitialDisabled.get(control);
      });
      if (match) anyShown = true;
    });
    routeFieldWrap.hidden = !anyShown;
  }

  if (subjectSelect) {
    var params = new URLSearchParams(window.location.search);
    var requestedReason = params.get('reason');

    if (requestedReason) {
      for (var i = 0; i < subjectSelect.options.length; i += 1) {
        if (subjectSelect.options[i].value === requestedReason) {
          subjectSelect.value = requestedReason;
          break;
        }
      }
    }

    syncSubjectButtons(subjectSelect.value);
    syncRouteCards(subjectSelect.value);
    syncRouteFields(subjectSelect.value);

    subjectButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var subject = button.getAttribute('data-contact-subject');
        if (!subject) return;
        subjectSelect.value = subject;
        syncSubjectButtons(subject);
        syncRouteCards(subject);
        syncRouteFields(subject);
        subjectSelect.dispatchEvent(new Event('change', { bubbles: true }));
        var messageField = section.querySelector('#ContactFormMessage');
        if (messageField) {
          messageField.focus();
        }
      });
    });

    routeCards.forEach(function (card) {
      card.setAttribute('role', 'button');
      card.setAttribute('aria-pressed', 'false');
      card.addEventListener('click', function () {
        var subject = card.getAttribute('data-contact-subject');
        if (!subject) return;
        subjectSelect.value = subject;
        syncSubjectButtons(subject);
        syncRouteCards(subject);
        syncRouteFields(subject);
        subjectSelect.dispatchEvent(new Event('change', { bubbles: true }));
        var form = section.querySelector('#contact-form');
        if (form && form.scrollIntoView) {
          form.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        }
        window.setTimeout(function () {
          var firstVisible = section.querySelector('[data-contact-route-field]:not([hidden]) input, [data-contact-route-field]:not([hidden]) select, [data-contact-route-field]:not([hidden]) textarea');
          var messageField = section.querySelector('#ContactFormMessage');
          if (firstVisible && firstVisible.focus) firstVisible.focus();
          else if (messageField && messageField.focus) messageField.focus();
        }, 250);
      });
    });

    subjectSelect.addEventListener('change', function () {
      syncSubjectButtons(subjectSelect.value);
      syncRouteCards(subjectSelect.value);
      syncRouteFields(subjectSelect.value);
    });
  }

  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      faqItems.forEach(function (other) {
        if (other !== item) {
          other.open = false;
        }
      });
    });
  });

  var revealItems = section.querySelectorAll('[data-reveal]');
  if (revealItems.length) {
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.setAttribute('data-reveal', 'active');
        item.classList.add('is-visible');
      });
    } else {
      var revealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-reveal', 'active');
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });

      revealItems.forEach(function (item, index) {
        item.style.setProperty('--contact-reveal-delay', Math.min(index * 70, 210) + 'ms');
        revealObserver.observe(item);
      });
    }
  }

  // Video toggle + reduced motion (WCAG 2.2.2)
  var videoToggle = section.querySelector('[data-contact-video-toggle]');
  if (videoToggle && heroVideo) {
    videoToggle.style.display = '';
    var pIcon = videoToggle.querySelector('.ag-contact__icon-pause');
    var plIcon = videoToggle.querySelector('.ag-contact__icon-play');
    function showContactPaused() { pIcon.style.display = 'none'; plIcon.style.display = 'block'; videoToggle.setAttribute('aria-label', 'Play video'); }
    function showContactPlaying() { pIcon.style.display = 'block'; plIcon.style.display = 'none'; videoToggle.setAttribute('aria-label', 'Pause video'); }

    function ensureHeroVideoSource() {
      var source = heroVideo.querySelector('source[data-src]');
      if (!source) return true;
      var nextSrc = source.getAttribute('data-src');
      if (!nextSrc) return false;
      source.setAttribute('src', nextSrc);
      source.removeAttribute('data-src');
      try { heroVideo.load(); } catch (e) {}
      return true;
    }

    function playHeroVideo() {
      ensureHeroVideoSource();
      heroVideo.muted = true;
      heroVideo.defaultMuted = true;
      heroVideo.playsInline = true;
      showContactPlaying();
      var p = heroVideo.play();
      if (p !== undefined) p.catch(showContactPaused);
    }

    function attemptHeroAutoplay() {
      if (!prefersReducedMotion() && heroVideo.paused) playHeroVideo();
    }

    heroVideo.addEventListener('canplay', attemptHeroAutoplay);

    videoToggle.addEventListener('click', function() {
      if (heroVideo.paused) playHeroVideo();
      else { heroVideo.pause(); showContactPaused(); }
    });

    function handleContactMotion(mq) {
      if (mq.matches) { heroVideo.pause(); showContactPaused(); }
      else { playHeroVideo(); }
    }
    if (reduceMotion) {
      handleContactMotion(reduceMotion);
      if (reduceMotion.addEventListener) { reduceMotion.addEventListener('change', handleContactMotion); }
      else if (reduceMotion.addListener) { reduceMotion.addListener(handleContactMotion); }
    } else {
      playHeroVideo();
    }

    if (prefersReducedMotion()) showContactPaused();
    else showContactPlaying();
  }
});
